import { createContext, useContext } from 'libs/react';
import { useLocation } from 'react-router-dom';
import { React } from 'libs/react';
import { useRoute } from 'components/router/Routing';
import { isGlobalSearchHidden } from './globalSearchRoutes';
/**
 * Whether a global search field may be rendered in this tree.
 *
 * Defaults to false, so any layout that does not opt in gets no field. That
 * default is what matters: PipeDriveComponent uses ScreenBar but is routed in
 * PublicLayout, where there is no session, no AccountProvider and no
 * authenticated Apollo client — a field there would fire GlobalSearchQuery
 * against the public endpoint.
 *
 * @hidden
 */
const GlobalSearchContext = createContext(false);
/**
 * Marks a tree as able to host the global search field. Mounted by MainLayout
 * only.
 *
 * @component GlobalSearchProvider
 * @since 1.0.0
 */
export function GlobalSearchProvider(props) {
    return (React.createElement(GlobalSearchContext.Provider, { value: true }, props.children));
}
/**
 * Whether the navigation bar should render a search field here.
 *
 * Two gates, because neither is sufficient alone: the context keeps the field
 * out of layouts that never opt in, and the route list keeps it out of screens
 * that opt in but should not show it.
 *
 * @function useGlobalSearchEnabled
 * @since 1.0.0
 */
export function useGlobalSearchEnabled() {
    const available = useContext(GlobalSearchContext);
    const route = useRoute();
    const location = useLocation();
    if (!available) {
        return false;
    }
    return !isGlobalSearchHidden(location.pathname, route.get);
}
